<template>
<div class="vdp-datepicker">
  <datePicker
    :format="format"
    lang="pt-br"
    :typeable="true"
    placeholder="00/00/0000"
    refName="datepicker"
    inputClass="form-control"
    v-model="date"
    :type="type"
    @change="onSelected"
  ></datePicker>
</div>
</template>

<script>
// eslint-disable-next-line
import DatePicker from 'vue2-datepicker'

export default {
  name: 'datepicker',
  components: { DatePicker },
  props: {
    model: {
      type: [Date, String],
      default: '',
    },
    selected: {
      type: Function,
      default: () => {},
    },
    type: {
      type: String,
      default: 'date',
    },
    format: {
      type: String,
      default: 'DD/MM/YYYY',
    },
  },
  computed: {
    date: {
      get() {
        return this.model;
      },
      set(val) {
        if (val) {
          this.$emit('update:model', val);
        }
      },
    },
  },
  methods: {
    onSelected(param) {
      if (param) {
        this.selected(param);
      }
    },
  },
};
</script>

<style lang='scss'>
.vdp-datepicker {
  .mx-datepicker {
    width: 100%;
    &-popup {
      border: none;
      min-width: 10rem;
      width: 300px;
    }
    .mx-input-append {
      display: none;
    }
    input {
      border-radius: 0.25rem !important;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    }
  }
}
</style>
<style lang="scss">
$white: #fff;
$black: #000;

$color-silver-sand: #c3c7cc;
$color-primary: #007bff;
$color-shuttle-gray: #5a6169;
$color-porcelain: #eceeef;

$border-color: transparent;
$border-radius-default: 0.375rem;
$transition-default: all 250ms cubic-bezier(0.27, 0.01, 0.38, 1.06);
$font-system: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
  "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
  "Segoe UI Symbol";

$datepicker-color: $color-shuttle-gray;
$datepicker-min-width: 10rem;
$datepicker-background-color: $white;
$datepicker-border-radius: $border-radius-default;
$datepicker-font-size: 1rem;
$datepicker-padding-x: 22px;
$datepicker-padding-y: 20px;
$datepicker-font-weight: 300;
$datepicker-border: 1px solid rgba($black, 0.05);
$datepicker-drop-shadows: 0 0.5rem 4rem rgba($black, 0.11),
  0 10px 20px rgba($black, 0.05), 0 2px 3px rgba($black, 0.06);

$datepicker-cell-width: 36px;
$datepicker-cell-height: 36px;
$datepicker-cell-hover-color: $color-porcelain;
$datepicker-cell-line-height: 2;
$datepicker-cell-font-size: 1rem;

$datepicker-small-padding-y: 0.625rem;
$datepicker-small-padding-x: 0.625rem;
$datepicker-small-font-size: 0.75rem;
$datepicker-small-max-width: 235px;

$datepicker-small-day-font-size: 12px;
$datepicker-small-day-font-weight: 500;
$datepicker-small-day-width: 1.875rem;
$datepicker-small-day-height: 1.875rem;
$datepicker-small-day-line-height: 2.25;

$datepicker-small-day-header-font-size: 100%;

.mx {
  &-calendar {
    color: $datepicker-color!important;
    padding: $datepicker-padding-y $datepicker-padding-x !important;
    min-width: $datepicker-min-width;
    font-size: $datepicker-font-size!important;
    font-weight: $datepicker-font-weight!important;
    font-family: $font-system!important;
    background-color: $datepicker-background-color;
    border: $datepicker-border;
    border-radius: $datepicker-border-radius;
    box-shadow: $datepicker-drop-shadows;
    border: 1px solid rgba($black, 0.15) !important;
    width: 300px!important;
    &-content {
      width: 100%!important;
      // Cells
      .cell {
        line-height: $datepicker-cell-line-height;
        font-size: $datepicker-cell-font-size;
        border-radius: $border-radius-default;
        transition: $transition-default;
        border-color: $border-color;
        height: auto;

        // Days
        width: $datepicker-cell-width;
        height: $datepicker-cell-height;
        border-radius: 50%;

        // Day headers
        &.day-header {
          font-weight: 500;
        }

        // Months
        &.month,
        &.year {
          height: $datepicker-cell-height;
          font-size: 12px;
          line-height: 33px;
        }

        // Selected
        &.actived,
        &.highlighted.actived {
          background: $color-primary !important;
          color: $white;
          &:hover {
            background: darken($color-primary, 5) !important;
            border-color: $border-color !important;
          }
        }

        &.highlighted {
          background: $color-primary;
          color: $white;

          &:hover {
            background: darken($color-primary, 5) !important;
            border-color: $border-color !important;
          }

          &:not(.highlight-start):not(.highlight-end) {
            border-radius: 0;
          }

          &.highlight-start {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }

          &.highlight-end {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
      }
    }

    // Header
    &-header {
      // display: flex;
      padding-bottom: 10px;

      a {
        transition: $transition-default;
        border-radius: $border-radius-default;
        font-weight: 500;

        &.next:after {
          border-left-color: $color-silver-sand;
        }

        &.prev:after {
          border-right-color: $color-silver-sand;
        }
      }
    }

    // Header elements and specific calendar cells.
    &-header span,
    .cell.day:not(.disabled):not(.blank),
    .cell.month,
    .cell.year {
      &:hover {
        background-color: $datepicker-cell-hover-color;
        border-color: $border-color !important;
      }
    }

  }

  // Small Datepicker modifier.
  &__small {
    padding: $datepicker-small-padding-y $datepicker-small-padding-x;
    font-size: $datepicker-small-font-size;
    max-width: $datepicker-small-max-width;

    .cell {
      width: $datepicker-small-day-width;
      height: $datepicker-small-day-height;
      line-height: $datepicker-small-day-line-height;

      &.cur-month,
      &.month,
      &.year {
        font-size: $datepicker-small-day-font-size;
        font-weight: $datepicker-small-day-font-weight;
      }

      &.day-header {
        font-size: $datepicker-small-day-header-font-size;
      }
    }
  }
}
</style>

